import React, { useState, ReactNode, ForwardedRef, forwardRef } from 'react';

interface FileTextBoxProps {
    label?: string;
    type: string;
    required?: boolean;
    name: string;
    icon?: ReactNode;
    placeholder?: string;
    prefix?: ReactNode;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: string;
    touched?: boolean;
    login?: boolean;
    value?: string;
}

const FileTextBox = forwardRef<HTMLInputElement, FileTextBoxProps>((props, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const showError = props.required && props.touched && !!props.error;

    return (
        <div className="block text-[12px] w-full">
            {props.label && (
                <div className="flex flex-row mb-0.5">
                    <label
                        className="block font-normal text-cyan-900 dark:text-gray-200 font-public-sans"
                        htmlFor={props.name}
                    >
                        {props.label}
                    </label>
                    {props.required && <span className="text-red-500 pl-1">*</span>}
                </div>
            )}
            <div>
                <input
                    type={props.type}
                    className={`placeholder:text-[11.5px] font-normal placeholder:select-none
                        placeholder:font-light dark:bg-transparent dark:text-gray-300 
                        placeholder:text-gray-400 placeholder:dark:text-gray-500 text-slate-600 text-[11px] font-public-sans w-full focus:outline-none 
                        ${props.login ? "ring-gray-400 placeholder:text-gray-400" : "ring-gray-400 placeholder:text-gray-300"}
                        ${props.prefix ? "my-[2.5px]" : showError ? "!ring-[1px] px-0.5 !ring-red-600 shadow-sm py-[2.5px] rounded-sm" :
                            "px-0.5 shadow-sm py-[2px] ring-[1px] dark:ring-sky-900 rounded-sm focus:ring-1 dark:focus:ring-green-400 focus:ring-green-600"}`}
                    id={props.name}
                    name={props.name}
                    onChange={props.handleChange || (() => {})}
                    onBlur={(e) => {
                        props.handleBlur && props.handleBlur(e);
                        setIsFocused(false);
                    }}
                    value={props.value}
                    placeholder={props.placeholder}
                    onFocus={() => setIsFocused(true)}
                    required={props.required}
                    ref={ref}
                />
            </div>
            {showError && <p className="text-red-500 text-[10px] mt-0.5">{props.error}</p>}
        </div>
    );
});

FileTextBox.displayName = 'FileTextBox';

export default FileTextBox;
